import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { ToastrService } from 'ngx-toastr';
import { AUTH_APIs } from 'src/app/constants/api.constants';
import { BackendService } from 'src/app/services/backend.service';
import { PDEHttpClient } from '../../../../src/app/services/pde-http-client.service';
import { backend } from 'src/environments/environment';
import { APIResponse } from 'src/app/models/common.models';
import { UserActivityService } from 'src/app/services/user-activity.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
    private pdeHttp: PDEHttpClient,
    private toastr: ToastrService,
    private userActivityService: UserActivityService
  ) { }

  async isAuthenticated(authUserType: string) {
    if(this.cookieService.hasKey("token")){
      return await this.getUserType().then((userType: APIResponse<String>) => {
        console.log("userType", userType)
        console.log("authUserType", authUserType)
        if(!userType.value)
          return null
        else{
          if(userType.value == 'Marketplace' && authUserType!='marketplace')
            return null
          else{
            switch(authUserType){
              case "marketplace":
                if(userType.value != 'Marketplace')
                  return "brand"
                else
                  return "marketplace"
              case "brand":
                if(userType.value != 'Marketplace')
                  return "brand"
                else
                  return "marketplace"
            }
          }
        }
      }).catch((err: any) => {
        return null
      })
    }
    else
      return null
  }

  async verifyToken() {
    return new Promise((resolve) => {
      resolve(true)
    })
  }

  getUserType() {
    return this.pdeHttp.authorizedGet<"Brand" | "Marketpalce">(AUTH_APIs.GET.userType)
  }

  async verifySupplierToken() {
    let token: any = this.cookieService.get("token")
    if (token) {
      return await this.http.post(`${backend}auth/supplier/verify-token`, {
        token: token
      }).toPromise().then((res: any) => {
        if (res["status"] != 200) {
          this.toastr.warning("Your session has expired. Please login again.")
          return null;
        }
        let now: any = new Date()
        let exp: any = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + 20, now.getSeconds());
        this.cookieService.put("token", token, {
          expires: exp,
          sameSite: "lax"
        });
        return token;
      }, err => {
        this.cookieService.remove("token");
        return null;
      })
    }
    else {
      return null;
    }
  }

  /**
   * Start monitoring user activity for authenticated users
   */
  startUserActivityMonitoring(): void {
    this.userActivityService.initializeActivityMonitoring();
  }

  /**
   * Stop monitoring user activity (e.g., on logout)
   */
  stopUserActivityMonitoring(): void {
    this.userActivityService.stopActivityMonitoring();
  }

  /**
   * Check if user activity monitoring is active
   */
  isUserActivityMonitoringActive(): boolean {
    return this.userActivityService.isMonitoringActive();
  }

  /**
   * Get remaining time before auto-logout (in seconds)
   */
  getRemainingSessionTime(): number {
    return this.userActivityService.getRemainingTime();
  }

}
